module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAMRJREFUWEftmEESRTAQRCdbN3EHDsCBOQB3cBNbSpWVCkWbL5Vfz9okrfM6IwmW2RMy02sI/vWKuTlc9vNgi1VRwcHGqSlqj4/xE9zNy5WgqS1c5nIZZBNaIji+Xjh8xjEMv91yCN2Jg4TuSeiU7pjUYYV7BD9CQmjnOJzEYSW9SoCUmigSykBf1SA4DcPCdgMSZhb7h4ZhGD44ABIgARK7AzQOGschDCDx30gI1//SsUqYx+3U/PYy8W49gu86pb6XncMraQhUPJ4CSGYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/download-selected.png
// module id = lsT7
// module chunks = 1